import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import FromCatalogWizard from 'modules/trainings/pages/MyTrainings/Requests/FromCatalogWizard'

export const CreateTrainingRequestFromCatalogActivity: ActivityComponent = () => {
  const { open, closeActivity } = useActivity()

  return <FromCatalogWizard isOpen={open} onClose={closeActivity} />
}
